/**
 * WikiPages/constants.ts
 * desc: wiki pages module constants
 * note: the new-page title prefix is deliberately not translated — titles are shared data
 */
export const NEW_PAGE_TITLE_PREFIX = 'New Page';
export const NEW_PAGE_TITLE_DATE_FORMAT = 'yyyy-MM-dd HH:mm:ss';
export const SELECTED_PAGE_STORAGE_KEY = 'wikiPagesSelectedPageId';
// the Wiki Pages entry has no route, so each nav gates it itself — any one of these grants it
export const WIKI_PAGES_PERMISSIONS = [ 'wiki:read', 'wiki:write' ];
export const AUTOSAVE_DELAY_MS = 1500;
// mirrors the API's limit
export const MAX_TITLE_LENGTH = 255;
